/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Project_Frame_RateInputs */



/**
* | output |
* | --- |
* | "Project Frame Rate" |
*
* @param {Editor_Project_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_project_frame_rate = /** @type {((inputs?: Editor_Project_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Project_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Frequence d'images du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildrate des Projekts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Frequenza dei fotogrammi del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частота кадров проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de fotogramas del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目帧速率")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのフレームレート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ्रेम दर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Taxa de quadros do projeto")
	return /** @type {LocalizedString} */ ("Project Frame Rate")
});